export const exportFilesCustomStylesIncadea = {
    //Colombia
    "1": {},
    //Peru
    "2": {},
    //Chile
    "3": {
        //Suzuki
        "1": () => import('./chile/suzuki/siteConfig').then(m => m.siteConfig),
        //Geely
        "4": () => import('./chile/geely/siteConfig').then(m => m.siteConfig),
        //Subaru
        "5": () => import('./chile/subaru/siteConfig').then(m => m.siteConfig),
        //DFSK
        "6": () => import('./chile/dfsk/siteConfig').then(m => m.siteConfig),
        //Mercedes Benz
        "7": () => import('./chile/mercedesBenz/siteConfig').then(m => m.siteConfig),
    },
    //Belgium
    "4": {},
    //Panama
    "5": {
        //Panama
        "1": () => import('./panama/suzuki/siteConfig').then(m => m.siteConfig),
    },
    //Costa Rica
    "6": {
        //Suzuki
        "1": () => import('./costaRica/suzuki/siteConfig').then(m => m.siteConfig),
        //Changan
        "2": () => import('./costaRica/changan/siteConfig').then(m => m.siteConfig),
        //Jac
        "3": () => import('./costaRica/jac/siteConfig').then(m => m.siteConfig),
    },
    //Kenia
    "7": {},
    //Philippines
    "8": {
         //Mercedes Benz
        "7": () => import('./philippines/mercedesBenz/siteConfig').then(m => m.siteConfig),
    },
    //Indonesia
    "9": {}
    }